module.exports = __webpack_public_path__ + "static/postgres_postgraphile_graphql-4b238552d875fe06196ba3bda74c6d2b.png";